// extracted by mini-css-extract-plugin
export default {"overlay":"SocketOverlay_overlay__hqfPu","message":"SocketOverlay_message__u8e2d","subMessage":"SocketOverlay_subMessage__hkmSl"};